import React, { useEffect, useRef, useState } from 'react'
import MainWrapper from '../components/Wrappers/MainWrapper'
import suggestionPrompt from '../assets/data/suggestionPrompt.json'
import surpriseMePrompt from '../assets/data/surpriseMePrompt.json'
import { Tooltip as ReactTooltip } from "react-tooltip";
import { useDispatch, useSelector } from 'react-redux';
import { useFetchFonts, useFetchFontsWithMd5Hash } from '../services/fontListService';
import { useGenerateImages } from '../services/imageService';
import { setOriginalUserPrompt, setPrompt } from '../redux/promptSlice';
import { setEmptyGeneratedImages, setIsVisualizePageVisible } from '../redux/createImageSlice';
import GenerateButton from '../components/buttons/GenerateButton';
import ModalsWrapper from '../components/Wrappers/ModalsWrapper';
import SuggestionButton from '../components/buttons/SuggestionButton';
import ImageSlider from '../components/ImageSlider/ImageSlider';
import TermsAndConditions from '../components/Modals/TermsAndConditions';
import { useUpdateUserData, useUserData } from '../services/userDataService';
import { showToast } from '../redux/toasterSlice';
import { usePastCreation } from '../services/pastCreationService';
import ReactGA from "react-ga4";
import closeIcon from '../assets/images/CloseIcon.svg';
import uploadImageIcon from '../assets/images/uploadImage.svg';
import { useUploadImage } from '../services/uploadImageService';
import { setUploadedImage } from '../redux/uploadImageSlice';
import { useNavigate, useParams } from 'react-router-dom';
import { setFontError, setFontLoading, setLastPayloadForUrlMd5, setRecommendedFontListFromMd5 } from '../redux/fontListSlice';
import { decryptArray } from '../utils/helpers';
import TipsForBestResults from '../components/ui/TipsForBestResults';
import disclaimers from '../assets/images/dangerSvg.svg'
import { setTermsAndConditions } from '../redux/authSlice';
import { usePromptSuggestion } from '../services/promptSuggestionService';
import { jwtDecode } from 'jwt-decode';
import TermandConditions from '../components/Modals/TermandConditions';

const VisualizeFontss = ({ token }) => {
    const { urlMd5, urlPrompt, '*': fontFamilyUrl } = useParams();
    const urlParams = new URLSearchParams(window.location.search);
    // 9c7f233b591f055acc0b60d328ae25b9/Packaging for a craft beer brand “Biro”
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { fetchFonts } = useFetchFonts();
    const generateImages = useGenerateImages();
    const { fetchFontsWithMd5, fetchSuggestions } = useFetchFontsWithMd5Hash();
    const updateUserData = useUpdateUserData();
    const pastCreation = usePastCreation();
    const uploadImage = useUploadImage();
    const getUserData = useUserData()
    const { fetchRecentlyUsedPrompts, fetchPromptSuggestions } = usePromptSuggestion()

    const abortControllerRef = useRef(null);
    const textareaRef = useRef(null);

    const { prompt } = useSelector((state) => state.prompt)
    const { isFontLoading } = useSelector((state) => state.fontList)
    const { isImageLoading, generatedImages } = useSelector((state) => state.createImage)
    const { name, email, userData, userDataLoading, userDataError, openTermsAndConditions, checkTermsAndConditions } = useSelector((state) => state.auth)
    const { pastCreationData, totalDocuments } = useSelector((state) => state.pastCreation);
    const { promptSuggestionLoading } = useSelector((state) => state.promptSuggestion);



    const [isFading, setIsFading] = useState(false);
    const [placeholderPrompt, setPlaceholderPrompt] = useState(suggestionPrompt[0] || "");
    const [tempPrompt, setTempPrompt] = useState("");
    // const [openTermsAndConditions, setOpenTermsAndConditions] = useState(false)
    const [base64Image, setBase64Image] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [imageFileName, setImageFileName] = useState(null);

    const [termsAndConditionsLocal, setTermsAndConditionsLocal] = useState(false);

    const disableGenerateButton = !userData?.termsAndConditions || (prompt.trim().length <= 0) || isFontLoading || isImageLoading;
    const disableUploadImageButton = !userData?.termsAndConditions || isFontLoading || isImageLoading;

    const generateImageHandler = async () => {
        const match = prompt.match(/<([^>]+)>/);
        const md5Pattern = /[a-f0-9]{32}/i;
        const md5Match = match !== null && match[1]?.match(md5Pattern);
        let promptId = "new"
        let font
        let searchPrompt

        fetchPromptSuggestions(prompt)
        fetchRecentlyUsedPrompts() // fetch recently used prompts

        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }

        const abortController = new AbortController();
        abortControllerRef.current = abortController;

        if (pastCreationData.length === 0) {
            pastCreation(1, searchPrompt, abortController.signal)
        }

        try {
            let image_description
            let magicPromptForImageUpload
            let uploadedImageLink
            dispatch(setIsVisualizePageVisible(false));

            ReactGA.gtag('event', 'generate_image', {
                action: 'Image generation from landing page',
                label: 'Image generation from landing page'
            });

            if (md5Match) {
                const md5hash = md5Match[0];
                font = await fetchFontsWithMd5(md5hash);
            } else {
                if (base64Image) {
                    const userImage = base64Image;
                    const response = await uploadImage(prompt, userImage, imageFileName);

                    image_description = response.image_description
                    magicPromptForImageUpload = response.magic_prompt
                    uploadedImageLink = response.uploadedImage
                }
                if (base64Image) {
                    font = await fetchFonts(image_description);
                } else {
                    font = await fetchFonts(prompt);
                }
            }
            if (!isFontLoading && !font) return

            if (base64Image) {
                await generateImages(promptId, image_description, font, magicPromptForImageUpload, uploadedImageLink);
            } else {
                await generateImages(promptId, prompt, font);
            }

            dispatch(setRecommendedFontListFromMd5([]))
        } catch (error) {
            console.error("Error during font fetching or image generation:", error);
        }
    };

    const surpriseMeHandler = async () => {
        let searchPrompt
        if (!userData.termsAndConditions) {
            dispatch(showToast({ message: "Please accept the terms and conditions to generate visuals", type: "error" }))
            return
        };
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }

        const abortController = new AbortController();
        abortControllerRef.current = abortController;

        if (pastCreationData.length === 0) {
            pastCreation(1, searchPrompt, abortController.signal)
        }

        let promptId = "new"
        const randomIndex = Math.floor(Math.random() * surpriseMePrompt.length);
        let prompt = surpriseMePrompt[randomIndex];
        fetchPromptSuggestions(prompt)
        fetchRecentlyUsedPrompts() // fetch recently used prompts
        dispatch(setPrompt(prompt));
        dispatch(setIsVisualizePageVisible(false))
        let font = await fetchFonts(prompt);
        if (!isFontLoading && !font) return
        await generateImages(promptId, prompt, font)

        ReactGA.gtag('event', 'surprise_me_button', {
            action: 'Suprise me button clicked',
            label: 'Suprise me button clicked'
        });
    }

    // const handleRedirectImageGeneration = async () => {
    //     ReactGA.gtag('event', 'generate_image_from_enterprise_started', {
    //         action: 'Image generation through redirection from enterprise',
    //         label: 'Image generation through redirection from enterprise'
    //     });

    //     let promptId = "new";
    //     let searchPrompt;

    //     const inventories = await decryptArray(urlParams.get('inventories'));

    //     const decoded = jwtDecode(token);

    //     // const inventories = decoded['https://secure.monotype.com/info']?.inventories || null;


    //     const fontNameFromParams = urlParams.get('fontName');

    //     const promptToUse = urlPrompt === "null" ? fontNameFromParams : urlPrompt;

    //     const suggestionPromptPromise = await fetchPromptSuggestions(promptToUse);

    //     fetchRecentlyUsedPrompts();
    //     dispatch(setOriginalUserPrompt(urlPrompt === "null" ? suggestionPromptPromise[0] : urlPrompt));
    //     dispatch(setFontLoading(true));
    //     dispatch(setIsVisualizePageVisible(false));
    //     navigate(`/generate-image`);
    //     dispatch(setLastPayloadForUrlMd5({ urlMd5, fontFamilyUrl, inventories, fontNameFromParams }));

    //     let fonts = {
    //         md5: urlMd5,
    //         font_name: fontNameFromParams,
    //         family_url: fontFamilyUrl || "",
    //         foundry_name: '',
    //     };
    //     dispatch(setRecommendedFontListFromMd5([fonts]));
    //     dispatch(setEmptyGeneratedImages());


    //     if (abortControllerRef.current) {
    //         abortControllerRef.current.abort();
    //     }

    //     const abortController = new AbortController();
    //     abortControllerRef.current = abortController;

    //     if (pastCreationData.length === 0) {
    //         pastCreation(1, searchPrompt, abortController.signal)
    //     }

    //     if (!urlMd5 || !fontNameFromParams) {
    //         dispatch(setFontError('Failed to fetch fonts from md5'));
    //         return;
    //     }

    //     let promptForSementicFont = urlPrompt === "null" ? suggestionPromptPromise[0] : urlPrompt

    //     const sementicFont = await fetchFonts(promptForSementicFont, inventories);
    //     if (!urlMd5 || !sementicFont) return;

    //     let suggestionPrompt = [];
    //     try {
    //         suggestionPrompt = await suggestionPromptPromise;
    //     } catch (err) {
    //         console.error("Failed to fetch prompt suggestions", err);
    //     }

    //     let generatedImage;

    //     if (suggestionPrompt?.length > 0 && suggestionPrompt[0] !== "Good Prompt") {
    //         dispatch(setPrompt(suggestionPrompt[0]));
    //         generatedImage = await generateImages(promptId, suggestionPrompt[0], fonts);
    //     } else {
    //         dispatch(setPrompt(urlPrompt));
    //         generatedImage = await generateImages(promptId, urlPrompt, fonts);
    //     }

    //     if (generatedImage?.status === 200) {
    //         ReactGA.gtag('event', 'generate_image_from_enterprise_completed', {
    //             action: 'Image generation through redirection from enterprise',
    //             label: 'Image generation through redirection from enterprise'
    //         });
    //     }
    // };

    const handleRedirectImageGeneration = async () => {
        try {
            ReactGA.gtag('event', 'generate_image_from_enterprise_started', {
                action: 'Image generation through redirection from enterprise',
                label: 'Image generation through redirection from enterprise'
            });
            dispatch(setFontLoading(true));

            // Extract and decode
            const decoded = jwtDecode(token);
            const inventories = await decryptArray(urlParams.get('inventories'));
            // const inventories = decoded['https://secure.monotype.com/info']?.inventories || null;
            const fontNameFromParams = urlParams.get('fontName');
            const promptId = "new";

            const isPromptNull = urlPrompt === "null";
            const promptToUse = isPromptNull ? fontNameFromParams + " font" : urlPrompt;

            if (!urlMd5 || (!fontNameFromParams && isPromptNull)) {
                dispatch(setFontError('Font name or md5 not available.'));
                return;
            }

            let suggestionPrompt = [];
            try {
                suggestionPrompt = await fetchPromptSuggestions(promptToUse);
            } catch (err) {
                console.error("Failed to fetch prompt suggestions", err);
            }

            // Dispatch initial state
            fetchRecentlyUsedPrompts();
            dispatch(setOriginalUserPrompt(isPromptNull ? suggestionPrompt[0] : urlPrompt));

            dispatch(setIsVisualizePageVisible(false));
            dispatch(setEmptyGeneratedImages());

            // Navigation
            navigate(`/generate-image`);

            // Save font data to store
            const fonts = {
                md5: urlMd5,
                font_name: fontNameFromParams,
                family_url: fontFamilyUrl || "",
                foundry_name: '',
            };
            dispatch(setLastPayloadForUrlMd5({ urlMd5, fontFamilyUrl, inventories, fontNameFromParams }));
            if (fontNameFromParams) {
                dispatch(setRecommendedFontListFromMd5([fonts]));
            }

            // Abort previous image generation if any
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            const abortController = new AbortController();
            abortControllerRef.current = abortController;

            // Past creation data
            if (pastCreationData.length === 0) {
                pastCreation(1, promptToUse, abortController.signal);
            }

            //  If fontNameFromParams is null, try fetching semantic fonts & use the first prompt
            if (!fontNameFromParams) {
                const fallbackPrompt = suggestionPrompt?.[0] || urlPrompt;

                if (!fallbackPrompt) {
                    dispatch(setFontError('Could not generate prompt from semantic font.'));
                    return;
                }

                const sementicFont = await fetchFonts(fallbackPrompt, inventories);
                if (!sementicFont) {
                    dispatch(setFontError('Failed to fetch semantic font.'));
                    return;
                }
                
                dispatch(setPrompt(fallbackPrompt));
                const generatedImage = await generateImages(promptId, fallbackPrompt, {
                    md5: sementicFont.md5,
                    font_name: sementicFont.font_name,
                    family_url: sementicFont.family_url || "",
                    foundry_name: '',
                });

                if (generatedImage?.status === 200) {
                    ReactGA.gtag('event', 'generate_image_from_enterprise_completed', {
                        action: 'Image generation through redirection from enterprise',
                        label: 'Image generation through redirection from enterprise'
                    });
                }
                return;
            }

            const sementicFont = await fetchFonts(promptToUse, inventories);
            if (!sementicFont) {
                dispatch(setFontError('Failed to fetch semantic font.'));
                return;
            }

            const finalPrompt = suggestionPrompt?.[0] && suggestionPrompt[0] !== "Good Prompt"
                ? suggestionPrompt[0]
                : urlPrompt;

            dispatch(setPrompt(finalPrompt));
            const generatedImage = await generateImages(promptId, finalPrompt, fonts);

            if (generatedImage?.status === 200) {
                ReactGA.gtag('event', 'generate_image_from_enterprise_completed', {
                    action: 'Image generation through redirection from enterprise',
                    label: 'Image generation through redirection from enterprise'
                });
            }

        } catch (error) {
            dispatch(setFontError('Image generation failed due to an unexpected error.'));
        }
    };

    const fetchSementicFont = async () => {
        const fontNameFromParams = urlParams.get('fontName');

        let fonts = {
            md5: urlMd5,
            font_name: fontNameFromParams,
            family_url: fontFamilyUrl || "",
            foundry_name: '',
        };


        const decoded = jwtDecode(token);

        const inventories = await decryptArray(urlParams.get('inventories'));
        // const inventories = decoded['https://secure.monotype.com/info']?.inventories || null;

        dispatch(setLastPayloadForUrlMd5({ urlMd5, fontFamilyUrl, inventories, fontNameFromParams }));

        const promptToUse = urlPrompt === "null" ? fontNameFromParams : urlPrompt;

        dispatch(setOriginalUserPrompt(promptToUse));

        await fetchFonts(promptToUse, inventories);

        dispatch(setRecommendedFontListFromMd5([fonts]));
    }

    const updateUserDataHandler = async (isChecked) => {

        setTermsAndConditionsLocal(prev => !prev);
        const params = {
            email: email,
            username: name,
            termsAndConditions: isChecked,
            globalUserId: urlParams.get('utm_campaign')
        }

        await updateUserData(params)

        if (isChecked) {
            ReactGA.gtag('event', 'terms_and_conditions', {
                action: 'terms and conditions accepted',
                label: 'terms and conditions accepted'
            });
            // if (urlMd5 || urlPrompt) {
            //     console.log("in function call");
            //     handleRedirectImageGeneration()
            // }
        }

    }

    const uploadImageHandler = (event) => {
        const file = event.target.files[0];
        if (file) {
            const fileName = file.name;
            const reader = new FileReader();

            reader.onload = () => {
                resizeImage(reader.result, 256, 256).then((resizedBlob) => {
                    convertImageToBase64(resizedBlob).then((base64String) => {
                        setBase64Image(base64String);
                        setImagePreview(`data:image/png;base64,${base64String}`);
                        setImageFileName(fileName);
                        dispatch(setUploadedImage({ base64String, fileName }));
                    });
                });
            };

            reader.readAsDataURL(file);
        }
    };

    // Function to resize an image (returns a Blob)
    function resizeImage(imageSrc, width, height) {
        return new Promise((resolve) => {
            const img = new Image();
            img.src = imageSrc;
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = width;
                canvas.height = height;
                ctx.drawImage(img, 0, 0, width, height);
                canvas.toBlob((blob) => resolve(blob), 'image/png');
            };
        });
    }

    // Function to convert Blob to Base64
    function convertImageToBase64(blob) {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                resolve(reader.result.split(',')[1]); // Extract only Base64 data
            };
            reader.readAsDataURL(blob);
        });
    }


    // useEffect for prompt box animation
    useEffect(() => {
        if (prompt.length > 0) return;
        setIsFading(true);
        const fadeOutTimeout = setTimeout(() => {
            setTempPrompt(placeholderPrompt);
            setIsFading(false);
        }, 900);

        return () => clearTimeout(fadeOutTimeout);
    }, [placeholderPrompt]);

    const handleRedirectImageGenerationNewUser = async () => {
        dispatch(setIsVisualizePageVisible(false));
        const fontNameFromParams = urlParams.get('fontName');
        dispatch(setFontLoading(true));

        let fonts = {
            md5: urlMd5,
            font_name: fontNameFromParams,
            family_url: fontFamilyUrl || "",
            foundry_name: '',
        };

        const decoded = jwtDecode(token);

        const inventories = await decryptArray(urlParams.get('inventories'));
        // const inventories = decoded['https://secure.monotype.com/info']?.inventories || null;

        dispatch(setLastPayloadForUrlMd5({ urlMd5, fontFamilyUrl, inventories, fontNameFromParams }));

        const promptToUse = urlPrompt === "null" ? fontNameFromParams : urlPrompt;
        const suggestionPrompt = await fetchPromptSuggestions(urlPrompt === "null" ? fontNameFromParams  + " font"  : urlPrompt);

        dispatch(setOriginalUserPrompt(urlPrompt === "null" ? suggestionPrompt[0] : urlPrompt));

        await fetchFonts(urlPrompt === "null" ? suggestionPrompt[0] : urlPrompt, inventories);

        if (fontNameFromParams) {
            dispatch(setRecommendedFontListFromMd5([fonts]));
        }
        dispatch(setTermsAndConditions(true))

    }

    useEffect(() => {
        setTermsAndConditionsLocal(userData?.termsAndConditions);
        if (urlMd5 && urlPrompt) {
            if (userData === null || userData.termsAndConditions === false) {
                // const fontNameFromParams = urlParams.get('fontName');
                // dispatch(setFontLoading(true));
                // fetchPromptSuggestions(urlPrompt === "null" ? fontNameFromParams : urlPrompt);
                // fetchSementicFont()
                // dispatch(setTermsAndConditions(true))
                // dispatch(setIsVisualizePageVisible(false));
                handleRedirectImageGenerationNewUser()
            } else if (userData?.termsAndConditions === true && (urlMd5 || urlPrompt)) {
                handleRedirectImageGeneration()
            }
        } else if (userData === null && !checkTermsAndConditions) {
            dispatch(setTermsAndConditions(true))
        }

    }, [userData]);

    useEffect(() => {
        const textarea = textareaRef.current;
        if (placeholderPrompt.length > 0 && !prompt) { }
        if (textarea) {
            textarea.style.height = "24px";
            textarea.style.overflowY = "hidden";
            textarea.style.height = `${Math.min(textarea.scrollHeight, 108)}px`;

            if (textarea.scrollHeight > 108) {
                textarea.style.overflowY = "auto";
            }
        }
    }, [prompt]);

    const tooltipContent = () => {
        if (userDataError || userData == null || userData?.termsAndConditions === false) return 'Please accept the terms and conditions to generate visuals';
        if (prompt.trim().length <= 0) return "Please enter a prompt to generate visuals"
        if (isFontLoading) return "Fetching fonts..."
        if (isImageLoading) return "Generating visuals..."
        return "Generate a new visual"
    }

    const tooltipContentUploadImage = () => {
        if (userDataError || userData == null || userData?.termsAndConditions === false) return 'Please accept the terms and conditions to upload image';
        if (isFontLoading) return "Fetching fonts..."
        if (isImageLoading) return "Generating visuals..."
        if (imagePreview) return "Change image"
        return "Upload image"
    }

    const Tooltip = ({ id, place, content }) => (
        <ReactTooltip
            id={id}
            place={place}
            content={content}
            style={{ backgroundColor: '#1E242C', borderRadius: '8px', fontSize: '13px', lineHeight: '16px', zIndex: '9999' }}
        />
    );

    if (urlMd5 && urlPrompt && userData !== null && userData.termsAndConditions !== false) return <></>;

    return (
        <MainWrapper>
            <div className='h-full px-[56px] py-[40px] flex items-center justify-between gap-[40px]'>
                {/* right side */}
                <div className='w-[747px] h-[664px] mt-[50px] flex flex-col items-center self-start gap-[80px]'>
                    <div className='flex flex-col gap-[56px] '>
                        <div className='flex flex-col gap-[8px] '>
                            <div className='flex gap-[8px]'>
                                <h1 className='text-[40px] tracking-[-0.02em] leading-[48px] font-helveticaDisp-Medium'><span className='text-pink-primary font-helveticaDisp-Medium'> Visualize fonts</span> with Monotype. </h1>
                            </div>
                            <p className='text-[19px] text-secondary leading-[32px] '>Watch your ideas come to life with the perfect font visualisation on packaging, apps, and beyond!”</p>
                        </div>
                        <div className=' flex flex-col gap-[24px] '>
                            <div className='w-full min-h-[72px] max-h-[140px] py-[12px] px-[16px] bg-[#FCFCFD] flex items-center gap-[8px] border rounded-[8px] '>
                                <div className='w-full flex items-center'>
                                    <textarea
                                        ref={textareaRef}
                                        rows={1}
                                        className="resize-none w-full px-[2px] bg-transparent outline-none leading-[24px] tracking-[-0.02em] placeholder:text-gray-primary caret-pink-primary"
                                        placeholder={tempPrompt}
                                        value={prompt}
                                        onChange={(e) => dispatch(setPrompt(e.target.value))}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter" && !e.shiftKey) {
                                                if (disableGenerateButton) return;
                                                e.preventDefault();
                                                generateImageHandler();
                                            }
                                        }}
                                        style={{
                                            animation: isFading ? "slideOut 0.7s forwards" : "slideIn 0.7s forwards",
                                        }}
                                    />
                                </div>


                                {prompt.length > 1 &&
                                    <div className='h-[40px] w-[20px] flex items-center justify-center self-start'>
                                        <img data-tooltip-id={`eraser`} id="eraser" onClick={() => dispatch(setPrompt(''))} className='h-[16px] w-[16px] cursor-pointer' src={closeIcon} alt="erase" />
                                    </div>
                                }
                                <div className='flex self-start gap-[8px] h-[48px] '>
                                    <GenerateButton
                                        data-tooltip-id="generate-visual"
                                        onClick={generateImageHandler}
                                        disableGenerateButton={!imagePreview && disableGenerateButton}
                                    />

                                    {/* <label
                                        data-tooltip-id="upload-image"
                                        className={`h-[48px] w-[50px] rounded-full flexCenter
                                             ${imagePreview ? "bg-cover bg-center" : "bg-pink-primary"}
                                             ${disableUploadImageButton ? "cursor-not-allowed opacity-[60%]" : "cursor-pointer"}
                                             `}
                                        style={imagePreview ? { backgroundImage: `url(${imagePreview})` } : {}}
                                    >
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={uploadImageHandler}
                                            className="hidden"
                                            disabled={disableUploadImageButton}
                                        />
                                        {!imagePreview && <img src={uploadImageIcon} alt="Upload Icon" />}
                                    </label> */}
                                </div>
                            </div>
                            <div className='flex items-center gap-[8px] '>
                                <input id="generate-buttons" type="checkbox" className='cursor-pointer accent-blue-500'
                                    checked={termsAndConditionsLocal}
                                    onChange={(e) => updateUserDataHandler(e.target.checked)}
                                />
                                <p className='tracking-[-0.02em] leading-[24px] font-[400] text-cus_secondary'>I agree to the Monotype’s  <a href='/terms-and-conditions' target="_blank" rel="noopener noreferrer" className='text-blue-primary '>terms and conditions</a>
                                </p>
                                <ModalsWrapper
                                    open={openTermsAndConditions || (!termsAndConditionsLocal && urlMd5)}
                                    onClose={() => {
                                        if (urlMd5) {
                                            updateUserDataHandler(false)
                                            ReactGA.gtag('event', 'terms_and_conditions_decline', {
                                                action: 'Terms and Conditions declined',
                                                label: 'Terms and Conditions declined'
                                            });
                                        };
                                        dispatch(setTermsAndConditions(false));
                                        navigate('/generate-image')
                                    }} >
                                    <TermandConditions
                                        handleAccept={() => {
                                            updateUserDataHandler(true);
                                            dispatch(setTermsAndConditions(false))
                                        }}
                                        handleDecline={() => {
                                            updateUserDataHandler(false);
                                            dispatch(setTermsAndConditions(false));
                                            navigate('/generate-image')
                                            ReactGA.gtag('event', 'terms_and_conditions_decline', {
                                                action: 'Terms and Conditions declined',
                                                label: 'Terms and Conditions declined'
                                            });
                                        }} />
                                    {/* <TermsAndConditions
                                        handleAccept={() => {
                                            updateUserDataHandler(true);
                                            dispatch(setTermsAndConditions(false))
                                        }}
                                        handleDecline={() => {
                                            updateUserDataHandler(false);
                                            dispatch(setTermsAndConditions(false));
                                            navigate('/generate-image')
                                            ReactGA.gtag('event', 'terms_and_conditions_decline', {
                                                action: 'Terms and Conditions declined',
                                                label: 'Terms and Conditions declined'
                                            });
                                        }} /> */}
                                </ModalsWrapper>
                            </div>
                        </div>
                    </div>
                    <div className='flex flex-col gap-[16px] small-texts text-gray-primary '>
                        <div className='flex flex-col gap-[8px] '>
                            <p className=' font-[500] leading-[16px] '>Looking for inspiration? Try this</p>
                            <div className='w-fit flex flex-col gap-[8px] '>
                                {suggestionPrompt.map((item, index) => (
                                    <SuggestionButton key={index} onClick={() => dispatch(setPrompt(item))} className='hover:bg-[#F3F4F6] text-start' >{item}</SuggestionButton>
                                ))}
                            </div>
                            <div className='w-fit flex flex-col gap-[8px]'>
                                <SuggestionButton onClick={surpriseMeHandler} className='hover:bg-[#F3F4F6]' >Surprise me</SuggestionButton>
                            </div>
                        </div>
                        <div className='p-[12px] bg-[#FCF6F2] rounded-[8px] flex flex-col gap-[8px] justify-center'>
                            <div className='flex gap-[8px]'>
                                <img src={disclaimers} alt="" className='h-[14px] w-[14px]' />
                                <p className='leading-[16px] text-[#DC5800] tracking-[-0.02rem] font-helveticaText-Medium'>Disclaimer</p>
                            </div>
                            <h5 className='text-[13px] leading-[16px] text-[#667488] text-justify hyphens-auto' >AI-generated visualizations aim to closely replicate original fonts; however, slight variations may occur.</h5>
                            <h5 className='text-[13px] leading-[16px] text-[#667488] text-justify' >
                                Portrait is designed to inspire users by showing how fonts look in visual settings. The main text reflects the chosen font, while smaller text may appear unreadable.
                                Please refer to our <a href='/terms-and-conditions' target="_blank" rel="noopener noreferrer" className='text-blue-primary '>terms and conditions</a> for more details on image usage guidelines.
                            </h5>
                        </div>
                    </div>
                </div>

                {/* left side*/}
                <div className='w-[548px] 2xl:w-[650px] aspect-[1/1]' style={{ aspectRatio: '1 / 1' }}>
                    <ImageSlider setPlaceholderPrompt={setPlaceholderPrompt} />
                </div>
            </div>

            <TipsForBestResults />

            <Tooltip id={`generate-visual`} place="top" content={tooltipContent()} />
            <Tooltip id={`upload-image`} place="top" content={tooltipContentUploadImage()} />
        </MainWrapper>
    )

}

export default VisualizeFontss